import { Button, Input, Popover, Select, Table, Tooltip, Tree, Image, Spin, message } from 'antd'
import type { TreeDataNode, TreeProps } from 'antd'
import { useEffect, forwardRef, useRef, useState, useImperativeHandle, useMemo } from 'react'
import styles from './index.module.less'

import DragEditTable from '@/components/DragEditTable'
import {
  CaretDownOutlined,
  CheckCircleFilled,
  CheckCircleOutlined,
  CopyOutlined,
  DownOutlined,
  EditOutlined,
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import SelectDrawer from '../components/SelectDrawer'
import {
  batchUpdateOrderSeq,
  batchUpdateSort,
  deleteByIdAndBudgetId,
  getAllSapce,
  getTradeEnums,
  listProductSkuRelationSpuFormat,
  queryChooseButton,
  quoteBudgetItemTree,
  quoteBudgetItemType,
  saveHouseInfo,
  updateBudgetField,
} from '@/services/order'
import { getListBudgetDtl } from '@/services/goodsFrontendTenant'
import dayjs from 'dayjs'
import { find, isArray, isBoolean, isEmpty } from 'lodash-es'
import { replaceRule } from '@/utils/data'
import tagsMap from '../utils'
import { useSearchParams } from 'react-router-dom'
import { treeToOneArr } from '@/common/utils'
import { useUpdateEffect } from 'ahooks'
import { treeToArray } from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/utils'
import ComfirmModal from '@/pages/orderServiceSpaceChoose/quoteSelection/components/ConfirmModal'
import { SDrawerOrModal, SGeneralForms, SMessage } from 'shj-components'
import ModifyStandard from '../../components/modifyStandard'
import HouseHoldManege from '@/pages/orderService/details/addQuotationDrawer/step2'
const { Search } = Input

const ChooseMaterial = forwardRef((props: any, ref) => {
  const { quoteBudgetInfo, budgetId, errorObj, getTopData } = props
  const houseTypeRef = useRef<any>()
  const [copyExpandedKeys, setCopyExpandedKeys] = useState<React.Key[]>([]) //备份展开
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([])
  const [searchValue, setSearchValue] = useState('')
  const [autoExpandParent, setAutoExpandParent] = useState(true)
  const [open, setOpen] = useState(false)
  const [householdOpen, setHouseholdOpen] = useState(false)
  const [skuSourceType, setSkuSourceType] = useState<any>('ALL') // 主材施工类型
  const [productSourceTypeBusList, setProductSourceTypeBusList] = useState<any>([]) // 主材施工类型
  const [chooseTypeList, setChooseTypeList] = useState<any>([]) // 可选材类型List
  const [btnList, setBtnList] = useState<any>([]) // 可选材按钮List
  const [selectType, setSelectType] = useState<any>('') // 当前选材类型
  const [spaceId, setSpaceId] = useState<any>(undefined) // 当前空间id
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState<any>([])
  const [searchParams] = useSearchParams()
  const [priceObj, setPriceObj] = useState<any>({})
  const [spaceList, setSpaceList] = useState<any>([])
  const [copySpaceList, setCopySpaceList] = useState<any>([]) //备份树data
  const [spaceOneArray, setSpaceOneArray] = useState<any>([])
  const [selectedKeys, setSelectedKeys] = useState<any>([])
  const [params, setParams] = useState<any>({})
  const [btnInfo, setBtnInfo] = useState<any>({})
  const [modifyOpen, setModifyOpen] = useState<any>()
  const [record, setRecord] = useState<any>({})
  const [chooseGeneralId, setChooseGeneralId] = useState<any>(undefined)
  const [qtyFormularLoading, setQtyFormularLoading] = useState(false) // 预算量计算式loading
  const [qtyFormularReadOnly, setQtyFormularReadOnly] = useState(false)
  const [budgetQtyFormularOpen, setBudgetQtyFormularOpen] = useState(false) // 预算量计算式弹窗
  const budgetQtyFormularRef = useRef<any>(null)
  const [recordItem, setRecordItem] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [houseLoading, setHouseLoading] = useState(false) // 户型loading
  const [modifyMode, setModifyMode] = useState<any>(undefined) // 修改规格模式
  const orderState = searchParams.get('orderState')
  const chooseTypeListRef = useRef<any>()
  chooseTypeListRef.current = chooseTypeList
  const onBudgetQtyFormularRef = () => {
    const { onFormRef } = budgetQtyFormularRef.current || {}
    return onFormRef?.()
  }
  useEffect(() => {
    getOptionList()
    // fetchList()
  }, [])
  const getOptionList = async () => {
    const list = await getTradeEnums(
      'com.shj.saas.plus.trade.domain.quote.enums.ProductSourceTypeBusEnum'
    )
    setProductSourceTypeBusList(
      list?.map(item => {
        return {
          label: item.description,
          value: item.key,
        }
      })
    )
    let typeList: any = await quoteBudgetItemType({
      quoteBudgetId: budgetId,
      sourceIdIsNull: true,
    })
    typeList = typeList.filter((item: any) => item?.code !== 'CHOOSE')
    setChooseTypeList(typeList)
    // 获取空间
    getSpace()
  }
  const getSpace = async () => {
    let resList: any = await getAllSapce(budgetId)
    if (resList && resList?.length) {
      resList = changeTreefied(resList)
      handleTree(resList)
      setSpaceList(resList)
      setCopySpaceList(resList)
    }
  }
  const reloadSpace = async () => {
    let resList: any = await getAllSapce(budgetId)
    if (resList && resList?.length) {
      resList = changeTreefied(resList)
      handleTree(resList)
      setSpaceList(resList)
    }
  }

  useImperativeHandle(ref, () => {
    return {
      reloadSpace,
    }
  }, [])

  const handleTree = array => {
    let oneArray = treeToOneArr(array)
    if (array && array?.length) {
      let expandedKeys: any = [] // 处理默认全部展开
      oneArray?.forEach((item: any) => {
        if (item?.children && item?.children?.length) {
          expandedKeys.push(item?.id)
        }
      })
      let defaultId = spaceId || oneArray[0]?.id
      setSelectedKeys([defaultId])
      setSpaceId(defaultId)
      setExpandedKeys(expandedKeys)
      setCopyExpandedKeys(expandedKeys)
    }
    console.log(oneArray, 'oneArray')

    setSpaceOneArray(oneArray)
  }
  const changeTreefied = (data: any) => {
    data.forEach((item: any) => {
      item.title = item?.object?.showName
      item.key = item?.id
      if (item.children?.length) {
        item.children = changeTreefied(item.children)
        item.selectable = false
      }
    })
    return data
  }

  const onDrop: TreeProps['onDrop'] = info => {
    const dropKey = info.node.key // 移动后当前节点的上一个位置的节点
    const dragKey = info.dragNode.key // 当前移动的节点
    const dropPos = info.node.pos.split('-') // 目标节点位置
    const dragPos = info.dragNode.pos.split('-') // 当前节点位置
    const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]) // the drop position relative to the drop node, inside 0, top -1, bottom 1
    if (
      dropPos?.splice(0, dropPos?.length - 1)?.join('') !==
      dragPos?.splice(0, dragPos?.length - 1)?.join('')
    ) {
      // 只允许当前层级移动
      return
    }
    if (dropPosition === 1) {
      const loop = (data, key, callback) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].key === key) {
            return callback(data[i], i, data)
          }
          if (data[i].children) {
            loop(data[i].children, key, callback)
          }
        }
      }
      const data = [...spaceList]
      // Find dragObject
      let dragObj
      loop(data, dragKey, (item, index, arr) => {
        arr.splice(index, 1)
        dragObj = item
      })
      if (!info.dropToGap) {
        // Drop on the content
        loop(data, dropKey, item => {
          item.children = item.children || []
          // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
          item.children.unshift(dragObj)
        })
      } else {
        let ar = []
        let i
        loop(data, dropKey, (_item, index, arr) => {
          ar = arr
          i = index
        })

        // 只允许平级移动
        if (dropPosition === -1) {
          // Drop on the top of the drop node
          ar.splice(i, 0, dragObj)
        } else {
          // Drop on the bottom of the drop node
          ar.splice(i + 1, 0, dragObj)
        }
      }
      setSpaceList(data)
      setCopySpaceList(data)
      upDateSort(data)
    }
  }
  const upDateSort = data => {
    let newData: any = treeToArray(data)
    newData = newData?.map(item => item?.id)
    batchUpdateSort(newData).then(res => {
      console.log(res)
    })
  }
  const showNationalTagRender = (item: any, type?) => {
    if (type === 'list') {
      if (item?.showTags && isArray(item?.showTags)) {
        return item?.showTags?.map((tag: any) => {
          return (
            <span
              className={'normal_tag_style'}
              style={{
                color: tagsMap.NATIONAL_UPPLEMENT?.color,
                backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
                marginRight: '8px',
              }}
            >
              {tag.tagName}
            </span>
          )
        })
      } else {
        return <></>
      }
    } else {
      // 显示国补
      if (item.packDtlList?.length > 0) {
        // 造数据
        item?.product?.combinationInfo.forEach((el: any) => {
          item?.packDtlList.forEach((pack: any) => {
            if (pack?.prdId === el?.id) {
              el.selectSkuId = pack?.sourceItemSnapshot?.productSku?.id
              el.checked = true
            }
          })
        })
        // 组合产品需判断除了施工项外是否全是国补 判断是否除了施工项都是国补 是则显示 国补标签
        let proList = item?.product?.combinationInfo
          ?.filter(item => item?.product?.sourceType !== 'CONSTRUCTION')
          ?.filter(item => item.required || (!item.required && item.checked))
        let allNational = false
        if (proList?.length) {
          allNational = proList?.every((el: any) => {
            if (el.selectSkuId) {
              return el?.skuList?.find((sku: any) => sku.id === el.selectSkuId)?.showTags
            }
            return false
          })
          if (allNational) {
            return (
              <span
                className={'normal_tag_style'}
                style={{
                  color: tagsMap.NATIONAL_UPPLEMENT?.color,
                  backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tagsMap.NATIONAL_UPPLEMENT.name}
              </span>
            )
          }
        }
      } else {
        let showTags = item?.product?.skuList?.find(
          (sku: any) => sku.id === item.prdSkuId
        )?.showTags
        if (showTags && isArray(showTags)) {
          return showTags?.map((tag: any) => {
            return (
              <span
                className={'normal_tag_style'}
                style={{
                  color: tagsMap.NATIONAL_UPPLEMENT?.color,
                  backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tag.tagName}
              </span>
            )
          })
        } else {
          return <></>
        }
      }
    }
  }
  const showTagsRender = item => {
    // 显示组合
    if (item?.packDtlList && item?.packDtlList.length) {
      return (
        <span
          className={'normal_tag_style'}
          style={{
            color: tagsMap.GROUP?.color,
            backgroundColor: tagsMap.GROUP?.bgColor,
            marginRight: '8px',
          }}
        >
          {tagsMap.GROUP.name}
        </span>
      )
    }
    // 显示失效标签
    if (item?.invalid) {
      return (
        <span
          className={'normal_tag_style'}
          style={{
            color: tagsMap.DISABLE?.color,
            backgroundColor: tagsMap.DISABLE?.bgColor,
            marginRight: '8px',
          }}
        >
          {tagsMap.DISABLE.name}
        </span>
      )
    }
    // 显示下架日期标签
    if (item?.outOfStockTime) {
      let localTime = new Date().getTime()
      let days: number = item?.outOfStockTime - localTime
      days = Math.ceil(days / (1000 * 60 * 60 * 24))
      return (
        <span
          className={'normal_tag_style'}
          style={{
            color: tagsMap.GROUP?.color,
            backgroundColor: tagsMap.GROUP?.bgColor,
            marginRight: '8px',
          }}
        >
          {days}天后下架
        </span>
      )
    }
  }

  const clickToDetail = record => {
    window.open(`/order/materialSelectionLibrary/materialDetail/${record?.prdId}`, '_blank')
  }
  const showChildNationalTag = (kit: any) => {
    // // 当确定skuid后 显示国补
    let showTags = kit?.skuList?.find((sku: any) => sku.id === kit?.selectSkuId)?.showTags
    if (showTags && isArray(showTags)) {
      return showTags?.map((tag: any) => {
        return (
          // <div className={tagsMap[tag.tagCode]} style={{ width: 'fit-content', maxWidth: '75px' }}>
          //   <Tooltip placement="topLeft" title={tag.tagName}>
          //     {tag.tagName}
          //   </Tooltip>
          // </div>
          <span
            className={'normal_tag_style'}
            style={{
              color: tagsMap.NATIONAL_UPPLEMENT?.color,
              backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
              marginRight: '8px',
            }}
          >
            {tag.tagName}
          </span>
        )
      })
    } else {
      return <></>
    }
  }
  const clickToCopy = value => {
    let dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    dummy.value = value
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    message.success('复制成功', 1)
  }
  const SkuRender = item => {
    // 判断是否有 多规格 组合 报价属性
    let modifyText
    if (
      (item?.dynaOptions && Object.keys(item?.dynaOptions).length) ||
      item?.materialDynaOptions?.length
    ) {
      const strings: string[] = []
      if (item?.materialDynaOptions?.length) {
        item?.materialDynaOptions?.forEach((el: any) => {
          strings.push(`${el.name}：${el.optionName}`)
        })
      }
      for (let key in item?.dynaOptions) {
        strings.push(`${item?.dynaOptions[key].argName}：${item?.dynaOptions[key].valueName}`)
      }
      modifyText = strings.map((str: string) => <div key={str}>{str}</div>)
    } else {
      modifyText = <span></span>
    }

    return (
      <div className={styles.skuCard}>
        <div className={styles.skuCard_baseInfo}>
          <div className={styles.baseInfo_imgBox}>
            <Image.PreviewGroup items={item?.imageUrls}>
              <Image src={item?.mainPic} />
            </Image.PreviewGroup>
          </div>
          <div>
            {showTagsRender(item)}
            {showNationalTagRender(item)}
            <span className={styles.name_box}>{item.name}</span>
            <p className={styles.spuBox}>
              <span>SKU：</span>
              {item?.prdSkuId}
              <CopyOutlined
                style={{ marginLeft: '8px' }}
                className="copyIcon"
                onClick={() => {
                  clickToCopy(item?.prdSkuId)
                }}
              />
            </p>
          </div>
        </div>
        <div className={styles.midify_box}>
          {modifyText && <div className={styles.dynation_box}>{modifyText}</div>}
          {item?.packDtlList && item?.packDtlList.length && (
            <div className={styles.group_box}>
              <div className={styles.group_box_title}>产品包明细</div>
              <div className={styles.item_list}>
                {item?.packDtlList?.map(el => {
                  return (
                    <div key={el.id}>
                      <div className={styles.skuCard_baseInfo}>
                        <div className={styles.baseInfo_imgBox}>
                          <Image.PreviewGroup items={el?.sourceItemSnapshot?.productSku?.imageUrls}>
                            <Image src={el?.sourceItemSnapshot?.productSku?.mainPicUrl} />
                          </Image.PreviewGroup>
                        </div>
                        <div>
                          <p className={styles.item_title}>
                            {showChildNationalTag(
                              item?.product?.combinationInfo?.find(kit => kit?.id === el?.prdId)
                            )}
                            {el?.sourceItemSnapshot?.productSku?.spuName}
                          </p>
                          <p className={styles.spuBox}>
                            <span>SPU：</span>
                            {el?.prdId}
                            <CopyOutlined
                              style={{ marginLeft: '8px' }}
                              className="copyIcon"
                              onClick={() => {
                                clickToCopy(el?.prdId)
                              }}
                            />
                          </p>
                          <div className={styles.modifyText_list}>{modifyTextRender(el)}</div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
  const modifyTextRender = item => {
    let modifyText
    if (
      (item?.dynaOptions && Object.keys(item?.dynaOptions).length) ||
      item?.materialDynaOptions?.length
    ) {
      const strings: string[] = []
      if (item?.materialDynaOptions?.length) {
        item?.materialDynaOptions?.forEach((el: any) => {
          strings.push(`${el.name}：${el.optionName}`)
        })
      }
      for (let key in item?.dynaOptions) {
        strings.push(`${item?.dynaOptions[key].argName}：${item?.dynaOptions[key].valueName}`)
      }
      modifyText = strings.map((str: string) => <div key={str}>{str}</div>)
    } else {
      modifyText = <span></span>
    }
    return modifyText
  }
  const columns: any = [
    { title: '序号', dataIndex: 'orderSeq', width: 75 },
    {
      title: '项目类型',
      dataIndex: 'typeNameList',
      width: 130,
      render: (text: any, record: any) => {
        if (record?.budgetDtlVoList?.length > 0) {
          return renderListFn(record, 'typeNameList')
        } else {
          return (
            text &&
            text?.map((str: string) => (
              <span
                key={str}
                className={'normal_tag_style'}
                style={{
                  color: tagsMap[str]?.color,
                  backgroundColor: tagsMap[str]?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tagsMap[str]?.name}
              </span>
            ))
          )
        }
      },
      filters: [
        { text: '通项', value: 'GENERAL' },
        { text: '标配', value: 'STANDARD' },
        { text: '非标配', value: 'NOTSTANDARD' },
        { text: '增项', value: 'ADD' },
        { text: '减项', value: 'SUB' },
        { text: '升降级', value: 'UP_DOWN' },
        { text: '活动', value: 'ACTIVITY' },
        { text: '项目', value: 'PROJECT' },
      ],
      filterSearch: true,
      onFilter: (value, record) => {
        return record.typeNameList?.includes(value)
      },
    },
    {
      title: '商品类型',
      dataIndex: 'name',
      width: 120,
      ellipsis: true,
      render: text => <span style={{ wordBreak: 'break-all' }}>{text}</span>,
    },
    {
      title: '商品',
      width: 400,
      dataIndex: 'pproduct',
      render: (text: any, record: any) => {
        const couldOperate =
          ((quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag) ||
            (record?.generalItemManageId && selectType !== 'SUB' && selectType !== 'ADD')) &&
          (orderState === 'waitSign' || orderState === 'effective' || orderState === 'inService')
        // 判断是否通项  通项budgetDtlVoList 为空是正常的 表示可以选材 其他类型 为空才取generalBudgetDtlVo
        let list
        if (record?.typeNameList?.includes('GENERAL') && record?.typeNameList?.length === 1) {
          list = record?.budgetDtlVoList
        } else {
          list =
            (record?.budgetDtlVoList?.length
              ? record?.budgetDtlVoList
              : [record?.generalBudgetDtlVo]) || []
        }
        if (isArray(list) && !!list?.length) {
          return list.map((item, index) => {
            return (
              // 有产品都只有这一种显示方式
              <div className={styles.productItemBox}>
                {showTagsRender(item)}
                {showNationalTagRender(item, 'list')}
                <Popover
                  overlayClassName={styles.Sku_popover}
                  className="skuName_box"
                  content={() => SkuRender(item)}
                  arrow={false}
                  placement="bottomLeft"
                >
                  {record?.generalItemManageId &&
                  record?.budgetDtlVoList?.length == 0 &&
                  !record?.typeNameList?.includes('SUB') ? null : (
                    <span onClick={() => clickToDetail(item)}>{item.name}</span>
                  )}
                </Popover>
              </div>
            )
          })
        }
      },
    },
    {
      title: '规格',
      width: 210,
      dataIndex: 'dynaOptions',
      ellipsis: true,
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 75,
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      align: 'right',
      width: 100,
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      width: 120,
      dataIndex: 'displayQtyFormular',
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '预算量',
      dataIndex: 'displayQtyValue',
      align: 'right',
      width: 100,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyValue'),
    },
    {
      title: '预算合计',
      width: 120,
      dataIndex: 'budgetAmount',
      align: 'right',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '选择日期',
      width: 150,
      dataIndex: 'createdTime',
      render: (text: any, record: any) => renderListFn(record, 'createdTime', undefined, 'date'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      ellipsis: true,
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
    {
      title: '操作',
      width: 80,
      dataIndex: 'action',
      fixed: 'right',
      render: (text: any, record: any) => {
        // 删除按钮显示： 先判断是否减项 是-》显示删除 否—》 按照budgetDtlVoList是否有值判断  是 删除 否选材
        let isSub = record?.typeNameList?.includes('SUB')
        let showDelete =
          record?.generalItemManageId &&
          record?.budgetDtlVoList?.length == 0 &&
          !record?.typeNameList?.includes('SUB')
        // record?.typeNameList?.includes('GENERAL') &&
        // record?.typeNameList?.length === 1 &&
        // record?.budgetDtlVoList?.length == 0
        if (isSub) {
          return (
            <Button
              color="primary"
              type="link"
              onClick={() => {
                deleteSku(
                  record?.budgetDtlVoList[0]?.id
                    ? record?.budgetDtlVoList[0]?.id
                    : record.budgetDtlId,
                  record
                )
              }}
              style={{ paddingLeft: 0 }}
            >
              删除
            </Button>
          )
        } else {
          return !showDelete ? (
            <Button
              color="primary"
              type="link"
              disabled={!record?.budgetDtlVoList[0]?.deletedFlag}
              onClick={() => {
                deleteSku(
                  record?.budgetDtlVoList[0]?.id
                    ? record?.budgetDtlVoList[0]?.id
                    : record.budgetDtlId,
                  record
                )
              }}
              style={{ paddingLeft: 0 }}
            >
              删除
            </Button>
          ) : (
            <Button
              color="primary"
              style={{ paddingLeft: 0 }}
              type="link"
              onClick={() => onAdd(record, null)}
            >
              选材
            </Button>
          )
        }
      },
    },
  ]
  const deleteSku = (id, record) => {
    let list
    if (record?.typeNameList?.includes('GENERAL') && record?.typeNameList?.length === 1) {
      list = record?.budgetDtlVoList
    } else {
      list =
        (record?.budgetDtlVoList?.length
          ? record?.budgetDtlVoList
          : [record?.generalBudgetDtlVo]) || []
    }
    SMessage.confirm({
      content: `确认删除选材"${list?.[0]?.name}"？`,
      onOk: () => {
        if (id) {
          return deleteByIdAndBudgetId({
            params: {
              id,
              budgetId,
            },
          }).then((res: any) => {
            message.success(res.message || '操作成功')
            fetchList()
            getTopData()
            getSpace()
            // getNewestPrice()
          })
        }
      },
    })
  }

  const renderListFn = (record: any, dataIndex: string, nodeRenderFn?: any, itemType?: any) => {
    let list
    if (record?.typeNameList?.includes('GENERAL') && record?.typeNameList?.length === 1) {
      list = record?.budgetDtlVoList
    } else {
      list =
        (record?.budgetDtlVoList?.length
          ? record?.budgetDtlVoList
          : [record?.generalBudgetDtlVo]) || []
    }

    return !!list?.length ? (
      <div>
        {list.map((item, index) => {
          let text: any = item?.[dataIndex]
          let midifyFlag =
            item.refType !== 'SUB' &&
            !item.refDeductId &&
            !item.templateFlag &&
            item.chooseFormatFlag
          let packDtlFlag =
            item.refType !== 'SUB' &&
            !item.refDeductId &&
            item.packDtlList &&
            !!item.packDtlList.length
          let skuDynamicFlag =
            item.refType !== 'SUB' &&
            !item.refDeductId &&
            item.skuDynamicVoList &&
            !!item.skuDynamicVoList.length
          if (!!text && itemType == 'dateTime') {
            text = dayjs(text).format('YYYY-MM-DD HH:mm:ss')
          }
          if (!!text && itemType == 'date') {
            text = dayjs(text).format('YYYY-MM-DD')
          }
          if (dataIndex.includes('Flag')) {
            if (isBoolean(text)) {
              text = text ? '是' : '否'
            }
            text = text == '1' ? '是' : text == '0' ? '否' : text
          }
          if (dataIndex === 'dynaOptions') {
            const strings: string[] = []
            if (
              (text && Object.keys(text).length) ||
              item?.materialDynaOptions?.length ||
              item?.packDtlList?.length ||
              item?.skuDynamicVoList?.length
            ) {
              if (item?.materialDynaOptions?.length) {
                item?.materialDynaOptions?.forEach((el: any) => {
                  strings.push(`${el.name}：${el.optionName}`)
                })
              }
              for (let key in text) {
                strings.push(`${text[key].argName}：${text[key].valueName}`)
              }
              return (
                <div className={styles.edit_box}>
                  {/* <Popover
                    overlayClassName={styles.Sku_popover}
                    className="skuName_box"
                    content={() => SkuRender(item)}
                    arrow={false}
                    placement="bottomLeft"
                  > */}
                  <Tooltip
                    title={
                      <div className={styles.edit_box_text}>
                        {strings.map((str: string) => (
                          <div>{str}</div>
                        ))}
                      </div>
                    }
                    placement="topLeft"
                    arrow={false}
                  >
                    <div className={styles.edit_box_text}>
                      {strings.map((str: string) => (
                        <span>{str}</span>
                      ))}
                    </div>
                  </Tooltip>
                  {/* </Popover> */}

                  <div className={styles.edit_box_icon}>
                    {(midifyFlag || packDtlFlag || skuDynamicFlag) && (
                      <EditOutlined
                        style={{ color: '#0064FF', cursor: 'pointer' }}
                        onClick={() => clickToModify(record)}
                      />
                    )}
                  </div>
                </div>
              )
            } else {
              text = <span></span>
            }
          }
          if (dataIndex === 'displayQtyFormular') {
            return (
              <div className={styles.edit_box}>
                <div className={styles.edit_box_text}>
                  <Tooltip
                    placement="topLeft"
                    arrow={false}
                    title={(text = replaceRule(text || ''))}
                  >
                    {(text = replaceRule(text || ''))}
                  </Tooltip>
                </div>
                <div className={styles.edit_box_icon}>
                  {
                    <EditOutlined
                      style={{ color: '#0064FF', cursor: 'pointer' }}
                      onClick={() => handleEditBudgetQtyFormular(item)}
                    />
                  }
                </div>
              </div>
            )
          }
          if (dataIndex === 'remark') {
            return (
              <div className={styles.edit_box}>
                <div className={styles.edit_box_text}>
                  <Tooltip placement="topLeft" arrow={false} title={text}>
                    {text}
                  </Tooltip>
                </div>
                <div className={styles.edit_box_icon}>
                  {
                    <EditOutlined
                      style={{ color: '#0064FF', cursor: 'pointer' }}
                      onClick={() => handleEditBudgetQtyFormular(item)}
                    />
                  }
                </div>
              </div>
            )
          }
          if (dataIndex === 'typeNameList') {
            text = text?.map((str: string) => (
              <span
                key={str}
                className={'normal_tag_style'}
                style={{
                  color: tagsMap[str]?.color,
                  backgroundColor: tagsMap[str]?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tagsMap[str]?.name}
              </span>
            ))
          }
          return (
            <Tooltip title={dataIndex !== 'typeNameList' && text} placement="topLeft" arrow={false}>
              <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                {text}
              </div>
            </Tooltip>
          )
        })}
      </div>
    ) : (
      <div>{record[dataIndex]}</div>
    )
  }
  const onAdd = (record, type) => {
    console.log('onAdd', record, type)
    if (!type && record?.generalItemManageId) {
      setOpen(true)
      setSelectType('GENERAL')
      setBtnInfo(null)
      setChooseGeneralId(record?.generalItemManageId)
      return
    }
    let btnInfo = btnList?.find(item => item?.code === type)
    setOpen(true)
    setSelectType(type)
    setBtnInfo(btnInfo)
  }
  const clickToModify = rowRecord => {
    let record = rowRecord?.budgetDtlVoList[0]
    if (record) {
      record.generalId =
        rowRecord?.typeNameList?.includes('ADD') || rowRecord?.typeNameList?.includes('PROJECT')
          ? ''
          : rowRecord?.generalItemManageId
      record.type = record.refType
      setRecord(record)
      setModifyMode('edit')
      // 如果套件明细数据，过滤调不显示的数据
      if (record.productSpu?.combinationInfo?.length > 1) {
        record.productSpu.combinationInfo = record.productSpu?.combinationInfo.filter(
          item => item.allowView
        )
        // 打开套件明细弹窗
        setModifyOpen(true)
        return
      }
      // // 如果有规格可以选择 提前选择
      setModifyOpen(true)
    }
  }
  const handleEditBudgetQtyFormular = async (item?: any) => {
    setQtyFormularReadOnly(false)
    if (item.quoteBudgetId !== budgetId) {
      setQtyFormularReadOnly(true)
    }
    console.log(item, 'item')

    setRecordItem(item)
    setBudgetQtyFormularOpen(true)
    onBudgetQtyFormularRef().setFieldsValue({
      remark: item.remark,
      budgetQtyFormular: item.standardFlag ? item.auditStandardQtyFormular : item.budgetQtyFormular,
      budgetQtyValue: item.standardFlag ? item.auditStandardQtyValue : item.budgetQtyValue,
    })
  }
  const onBudgetQtyFormularSubmit = async value => {
    setQtyFormularLoading(true)
    updateBudgetField({
      data: {
        id: recordItem.id,
        ...onBudgetQtyFormularRef().getFieldsValue(),
      },
    })
      .then(res => {
        setBudgetQtyFormularOpen(false)
        fetchList()
        getTopData()
      })
      .finally(() => {
        setQtyFormularLoading(false)
      })
  }
  const onChangeCalculate = val => {
    if (val) {
      let funcRes: any = ''
      try {
        const func = new Function(`return ${val}`)
        funcRes = func()
      } catch (err) {
        funcRes = false
      }
      funcRes = typeof funcRes === 'number' ? Number(funcRes.toFixed(4)) : funcRes
      console.log(funcRes)
      onBudgetQtyFormularRef().setFieldsValue({
        budgetQtyValue: funcRes === false ? '计算式错误' : funcRes,
      })
    } else {
      onBudgetQtyFormularRef().setFieldsValue({
        budgetQtyValue: null,
      })
    }
  }

  const getParentKey = (key: React.Key, tree: TreeDataNode[]): React.Key => {
    let parentKey: React.Key
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some(item => item.key === key)) {
          parentKey = node.key
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children)
        }
      }
    }
    return parentKey!
  }
  const onExpand = (newExpandedKeys: React.Key[]) => {
    setExpandedKeys(newExpandedKeys)
    setAutoExpandParent(false)
  }
  // useEffect(() => {

  // }, [searchValue])
  // 改造数据
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    console.log(value, 'value')

    const newExpandedKeys = spaceOneArray
      .map(item => {
        if (item.title.indexOf(value) > -1) {
          return getParentKey(item.key, spaceList)
        }
        return null
      })
      .filter((item, i, self): item is React.Key => !!(item && self.indexOf(item) === i))
    console.log(newExpandedKeys, 'newExpandedKeys包含的项')

    setExpandedKeys(newExpandedKeys)
    setSearchValue(value)
    setAutoExpandParent(true)
  }
  const treeData = useMemo(() => {
    const loop = (data: TreeDataNode[]): TreeDataNode[] =>
      data
        .map(item => {
          const strTitle = item.title as string
          const index = strTitle.indexOf(searchValue)
          const beforeStr = strTitle.substring(0, index)
          const afterStr = strTitle.slice(index + searchValue.length)
          const title = strTitle
          if (item.children) {
            return { title, key: item.key, children: loop(item.children) }
          }

          return index > -1
            ? {
                ...item,
                title,
              }
            : {
                ...item,
                title: null,
              }
        })
        .filter(item => !!item.title)
    console.log(loop(spaceList), '333333333')

    return loop(spaceList).filter((el: any) => {
      if (!el?.children?.length) {
        return el?.title.indexOf(searchValue) > -1
      } else {
        return el
      }
    })
  }, [searchValue, spaceList])

  const priceHandle = price => {
    if (price) {
      let priceStr = numFormat({ value: price })
      const [int, dec] = priceStr.split('.')
      if (Number(dec)) {
        return (
          <>
            {int}
            <span className={styles.priceBoxSmall}>.{dec}</span>
          </>
        )
      } else {
        return int
      }
    } else {
      return <span>{0}</span>
    }
  }
  const onClose = (isMultiple: boolean, list = []) => {
    if (selectType !== 'SUB' && isMultiple && list?.length) {
      SMessage.confirm({
        title: `退出选材`,
        content: '确认退出选材吗？退出后批量空间设置将被清空',
        okText: '继续',
        onOk: () => {
          setOpen(false)
          fetchList()
          getTopData()
          getSpace()
        },
      })
      return
    }
    setOpen(false)
    fetchList()
    getSpace()
    getTopData()
  }
  const clickToHouseholdManage = () => {
    setHouseholdOpen(true)
  }
  const onProductSourceTypeBusChange = e => {
    setSkuSourceType(e)
    let param = { ...params }
    param.skuSourceType = e
    setParams({ ...param })
    fetchList(param)
  }
  const getBtnList = () => {
    queryChooseButton({
      spaceId: spaceId,
      quoteBudgetId: budgetId,
    }).then((res: any) => {
      if (res && res.length) {
        res = res.map((item: any) => {
          return {
            ...item,
            showName: tagsMap[item.type].name,
            code: item.type,
            id: item.refItemId || null,
          }
        })
        console.log(res, '22222222')
        setBtnList(res)
      }
    })
  }
  useEffect(() => {
    setBtnList([])
    spaceId && fetchList()
    spaceId && getBtnList()
  }, [spaceId])
  const fetchList = async (param?: any) => {
    setLoading(true)
    let resData: any
    try {
      resData = await getListBudgetDtl({
        data: {
          budgetId: budgetId,
          spaceId: param?.spaceId ? param?.spaceId : spaceId,
          skuSourceType: param?.skuSourceType
            ? param?.skuSourceType === 'ALL'
              ? null
              : param?.skuSourceType
            : skuSourceType === 'ALL'
              ? null
              : skuSourceType,
        },
      })
      // if (resData && resData.length) {
      //   let generalItem = resData.find((item: any) => item.generalItemManageId !== undefined)
      //   setSelectType(generalItem ? 'GENERAL' : 'PROJECT')
      //   // handleTypeList(generalItem ? 'GENERAL' : 'PROJECT')
      // } else {
      //   // setSelectType('PROJECT')
      //   // handleTypeList('PROJECT')
      // }
      resData = resData.map((item: any, index) => {
        return {
          ...item,
          orderSeq: index + 1,
          key: index + 1,
        }
      })
      dataHanlde(resData)
      setDataSource(resData)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  const onSelect = (selectedKeys, info) => {
    console.log(selectedKeys)
    if (selectedKeys && selectedKeys.length) {
      let param = { ...params }
      param.spaceId = selectedKeys[0]
      setParams({ ...param })
      setSpaceId(selectedKeys[0])
      // fetchList(param)
    }
    setSelectedKeys(selectedKeys)
  }

  const dataHanlde = (data: any) => {
    console.log(data)
    let priceObj = {} // 计算金额
    if (data && data.length) {
      data.forEach((record: any) => {
        let list
        if (record?.typeNameList?.includes('GENERAL') && record?.typeNameList?.length === 1) {
          list = record?.budgetDtlVoList
        } else {
          list =
            (record?.budgetDtlVoList?.length
              ? record?.budgetDtlVoList
              : [record?.generalBudgetDtlVo]) || []
        }
        if (list.length) {
          list.forEach((el: any) => {
            priceObj[el.refType] =
              Number(priceObj[el?.refType] || 0) + Number(el?.budgetAmount ?? 0)
          })
        }
      })
      for (let key in priceObj) {
        priceObj['ALL'] = Number(priceObj['ALL'] ?? 0) + Number(priceObj[key] ?? 0)
      }
    }
    setPriceObj(priceObj)
  }
  const onSaveHouseType = () => {
    const spaceBudgetItemList = houseTypeRef.current?.data || []
    const notShowName = spaceBudgetItemList.some(item => !item.showName)
    if (notShowName) return message.error('显示名称不能为空')
    setHouseLoading(true)
    saveHouseInfo({
      data: spaceBudgetItemList?.map((item: any, index: number) => {
        return { ...item, sort: index + 1 }
      }),
    })
      .then(res => {
        message.success(res.message || '操作成功')
        setHouseholdOpen(false)
        getOptionList()
        // setState({ record: {} })
      })
      .finally(() => setHouseLoading(false))
  }
  const titleRender = (nodeData: any) => {
    const { title } = nodeData
    const typeObj: any = {}
    // dataSource?.forEach((item: any) => {
    if (nodeData?.object?.chooseTypeEnums?.length) {
      nodeData?.object?.chooseTypeEnums?.forEach((el: any) => {
        if (['ADD', 'SUB', 'UP_DOWN', 'ACTIVITY'].includes(el)) {
          typeObj[el] = tagsMap[el]?.name
        }
      })
    }
    let nameStr = Object?.values(typeObj)?.join('、')
    let errorFlag = errorObj?.itemList?.some((el: any) => el?.id === nodeData?.id)

    return (
      <div
        className={`${styles.treeTitle}  ${nodeData?.children?.length ? 'hasChildren-node' : 'child-node'} `}
        title=""
      >
        <Tooltip
          title={`${errorObj ? title : `${title}${nameStr ? '：' + nameStr : ''}`}`}
          placement="topLeft"
          arrow={false}
        >
          <span
            className={`${styles.text}  ${searchValue && title?.indexOf(searchValue) > -1 ? styles.highLight_class : ''}`}
          >
            {title}
          </span>
        </Tooltip>
        {errorObj && errorObj?.itemList?.length ? (
          <div className={styles.circle_icon}>
            {errorFlag ? (
              <ExclamationCircleFilled style={{ color: '#F59300' }} />
            ) : (
              <CheckCircleFilled style={{ color: '#00A865' }} />
            )}
          </div>
        ) : (
          <div className={styles.circle_icon}>
            {Object.keys(typeObj)?.map((el: any, index: number) => {
              return <p key={index} className={`${styles.circle} ${styles[el]}`}></p>
            })}
          </div>
        )}
      </div>
    )
  }
  const switcherIconRender = node => {
    return <CaretDownOutlined style={{ fontSize: 12 }} />
  }
  const rowClassName = record => {
    let classStr = ''
    if (errorObj?.dtlList?.length) {
      errorObj?.dtlList?.forEach((item: any) => {
        if (spaceId === item?.spaceId) {
          // 判断当前空间
          let itemId =
            record?.budgetDtlVoList && record?.budgetDtlVoList?.length
              ? record?.budgetDtlVoList[0]?.id
              : record?.budgetDtlId
          if (itemId === item?.id) {
            classStr = 'error-class'
          }
        }
      })
    }
    return classStr
  }
  const sortTable = (data: any) => {
    console.log(data)
    data = data?.map((item: any) => {
      if (item?.budgetDtlVoList?.length) {
        return item?.budgetDtlVoList[0]?.id
      } else {
        return item?.budgetDtlId
      }
    })
    batchUpdateOrderSeq(data).then(() => {
      message.success('更新成功')
      fetchList()
    })
  }
  const reloadAll = () => {
    getTopData()
    fetchList()
  }
  return (
    <div className={styles.chooseMaterialBox}>
      <Spin spinning={loading}>
        <div className={styles.chooseMaterialBox_left}>
          <div className={styles.chooseMaterialBox_left_title}>
            <p className={styles.title}>
              空间({spaceOneArray?.filter(item => !item?.children?.length)?.length})
            </p>
            <PlusOutlined className={styles.plusBtn} onClick={clickToHouseholdManage} />
          </div>
          <Search
            style={{ margin: '4px 12px', width: 156 }}
            placeholder="搜索空间"
            onChange={onChange}
          />
          <Tree
            className="draggable-tree"
            draggable
            blockNode
            // onDragEnter={onDragEnter}
            onDrop={onDrop}
            treeData={treeData}
            selectedKeys={selectedKeys}
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            autoExpandParent={autoExpandParent}
            onSelect={onSelect}
            titleRender={titleRender}
            // switcherIcon={switcherIconRender}
            // showIcon={false}
          />
        </div>
        <div className={styles.chooseMaterialBox_right}>
          <div className={styles.chooseMaterialBox_right_title}>
            <div className={styles.right_title_left}>
              {spaceOneArray?.find(item => item.id === spaceId)?.title}
            </div>
            <div className={styles.right_title_right}>
              <div className={styles.right_title_money}>
                <p> 合计：</p>
                <div className={styles.priceBox}>
                  <span className={styles.priceBoxSmall}>￥</span>
                  {<>{priceHandle(priceObj?.ALL)}</>}
                </div>
              </div>
              <div className={styles.right_title_money}>
                <p> 增项：</p>
                <div className={styles.priceBox}>
                  <span className={styles.priceBoxSmall}>￥</span>
                  {<>{priceHandle(priceObj?.ADD)}</>}
                </div>
              </div>
              <div className={styles.right_title_money}>
                <p> 项目：</p>
                <div className={styles.priceBox}>
                  <span className={styles.priceBoxSmall}>￥</span>
                  {<>{priceHandle(priceObj?.PROJECT)}</>}
                </div>
              </div>
              <div className={styles.right_title_money}>
                <p> 减项：</p>
                <div className={styles.priceBox}>
                  <span className={styles.priceBoxSmall}>￥</span>
                  {<>{priceHandle(priceObj?.SUB)}</>}
                </div>
              </div>
              <div className={styles.right_title_money}>
                <p> 升降级：</p>
                <div className={styles.priceBox}>
                  <span className={styles.priceBoxSmall}>￥</span>
                  {<>{priceHandle(priceObj?.UP_DOWN)}</>}
                </div>
              </div>
              <div className={styles.right_title_money}>
                <p> 活动：</p>
                <div className={styles.priceBox}>
                  <span className={styles.priceBoxSmall}>￥</span>
                  {<>{priceHandle(priceObj?.ACTIVITY)}</>}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.right_toolBar} id="right_toolBar">
            <div>
              <Select
                style={{ width: 160 }}
                onChange={onProductSourceTypeBusChange}
                showSearch
                value={skuSourceType}
                options={[{ label: '全部', value: 'ALL' }, ...productSourceTypeBusList]}
                optionFilterProp="label"
                getPopupContainer={(): HTMLElement => document.getElementById('right_toolBar')!}
              />
            </div>
            <div className={styles.right_toolBar_btns}>
              {btnList?.map((item: any) => {
                if (item?.type !== 'GENERAL' && item?.type !== 'PROJECT') {
                  return (
                    <Button
                      color="primary"
                      variant="outlined"
                      style={{ marginLeft: 10 }}
                      onClick={() => onAdd(null, item?.code)}
                    >
                      新增{item?.showName}
                    </Button>
                  )
                } else {
                  return (
                    <Button
                      type="primary"
                      style={{ marginLeft: 10 }}
                      onClick={() => onAdd(null, item?.code)}
                    >
                      {item?.code === 'GENERAL' ? '通项选材' : '项目选材'}
                    </Button>
                  )
                }
              })}
            </div>
          </div>
          <DragEditTable
            rowKey="key"
            columns={columns}
            dataSource={dataSource}
            setDataSource={setDataSource}
            showSortTitle={false}
            antdProps={{
              scroll: { x: '900px', y: dataSource?.length ? '500px' : null },
              loading: loading,
              rowClassName: rowClassName,
            }}
            sortTable={sortTable}
          ></DragEditTable>
          {open && (
            <SelectDrawer
              open={open}
              onClose={onClose}
              chooseTypeList={btnList}
              selectType={selectType}
              setSelectType={setSelectType}
              budgetId={budgetId}
              spaceId={spaceId}
              spaceOneArray={spaceOneArray}
              btnInfo={btnInfo}
              chooseGeneralId={chooseGeneralId}
            ></SelectDrawer>
          )}
          {modifyOpen && (
            <ComfirmModal
              open={modifyOpen}
              setOpen={setModifyOpen}
              record={record}
              type={record.type}
              budgetId={budgetId}
              spaceId={spaceId}
              generalId={record?.generalId}
              btnInfo={btnInfo}
              modifyMode={modifyMode}
              reload={reloadAll}
            ></ComfirmModal>
          )}

          <SDrawerOrModal
            mode="drawer"
            open={householdOpen}
            title="户型管理"
            onCancel={() => setHouseholdOpen(false)}
            antdProps={{
              footer: [
                <Button
                  key="cancel"
                  onClick={() => setHouseholdOpen(false)}
                  style={{ marginRight: 10 }}
                >
                  取消
                </Button>,
                <Button key="save" type="primary" loading={houseLoading} onClick={onSaveHouseType}>
                  保存
                </Button>,
              ],
            }}
            // onOk={onSaveHouseType}
          >
            {householdOpen && (
              <HouseHoldManege
                ref={houseTypeRef}
                isEdit={true}
                // couldOperate={state.record?.state === 'budgetDraft' && !state.record?.frozenFlag}
                detailInfo={quoteBudgetInfo}
                query={{ quoteBudgetId: quoteBudgetInfo?.id }}
              />
            )}
          </SDrawerOrModal>
          <SDrawerOrModal
            mode="modal"
            open={budgetQtyFormularOpen}
            loading={qtyFormularLoading}
            onCancel={() => setBudgetQtyFormularOpen(false)}
            styles={{ body: { padding: '0 15px' } }}
            onOk={onBudgetQtyFormularSubmit}
            width={400}
            title="预算量"
            antdProps={{
              ...{
                ...(qtyFormularReadOnly ? { footer: null } : {}),
              },
            }}
          >
            <SGeneralForms
              ref={budgetQtyFormularRef}
              layout={'vertical'}
              configs={[
                {
                  formItem: [
                    {
                      label: '预算量计算式',
                      name: 'budgetQtyFormular',
                      spanCol: 24,
                      comConfig: {
                        disabled: !recordItem?.updateFormularFlag || qtyFormularReadOnly,
                        onChange: e => onChangeCalculate(e?.target?.value),
                      },
                    },
                    {
                      label: '预算量',
                      name: 'budgetQtyValue',
                      spanCol: 24,
                      comConfig: {
                        disabled: true,
                      },
                    },
                    {
                      label: '备注',
                      name: 'remark',
                      spanCol: 24,
                      type: 'textarea',
                      comConfig: {
                        disabled: qtyFormularReadOnly,
                        autoSize: true,
                        maxLength: 255,
                        showCount: true,
                      },
                    },
                  ],
                },
              ]}
            />
          </SDrawerOrModal>
        </div>
      </Spin>
    </div>
  )
})
export default ChooseMaterial
